// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"697":"335a7dea212ace55","936":"aa77774e264fa284"}[chunkId] + ".js";
};